import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import WarningIcon from '@material-ui/icons/Warning';
import { countOrACVFormatter } from '../../../util/customFunctions';

const useStyles = makeStyles((theme) => ({
  conflictDialog: {
    '& .MuiDialog-paper': {
      borderRadius: '8px',
      padding: theme.spacing(2),
      minWidth: '700px',
    },
  },
  conflictTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    color: '#f57c00',
  },
  conflictWarningIcon: {
    color: '#f57c00',
  },
  conflictTableContainer: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  conflictTableCell: {
    backgroundColor: '#4472c4',
    color: theme.palette.common.white,
    fontWeight: 'bold',
  },
  conflictQuestion: {
    marginTop: theme.spacing(2),
    fontWeight: 600,
    textAlign: 'center',
  },
  conflictDialogActions: {
    justifyContent: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
  },
}));

const ConflictDialog = ({ open, onClose, onConfirm, conflictData, hideRampStatus = false }) => {
  const classes = useStyles();

  const getRepNameFromConflictData = () => {
    if (conflictData && conflictData.length > 0 && conflictData[0].fullName) {
      return {text:conflictData[0].fullName, prefix:'Rep'}
    } else if (conflictData && conflictData.length > 0 && conflictData[0].displayName) {
      return {text:conflictData[0].displayName, prefix:'Team'}
    }
    return {text:'Company',prefix:''};
  };
  const descriptionTextVal = getRepNameFromConflictData()
  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={classes.conflictDialog}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>
        <div className={classes.conflictTitle}>
          <WarningIcon className={classes.conflictWarningIcon} />
          <Typography variant="h6">Quota Already Exists</Typography>
        </div>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          {descriptionTextVal.prefix} <span style={{ fontWeight: 600 }}>{descriptionTextVal.text}</span> already has the following quota entries:
        </Typography>

        <TableContainer component={Paper} className={classes.conflictTableContainer}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell className={classes.conflictTableCell}>Fiscal Qtr.</TableCell>
                <TableCell className={classes.conflictTableCell}>Quota</TableCell>
                <TableCell className={classes.conflictTableCell}>NQP Goal</TableCell>
                {!hideRampStatus && (
                  <TableCell className={classes.conflictTableCell}>Ramp Status</TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {conflictData.filter(item => item.canUpsert === false).map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{item.fiscalQuarter}</TableCell>
                  <TableCell>{countOrACVFormatter(item.currentValue?.quota, true)}</TableCell>
                  <TableCell>{countOrACVFormatter(item.currentValue?.nqpGoal, true)}</TableCell>
                  {!hideRampStatus && (
                    <TableCell>{item.currentValue?.rampStatus || 'N/A'}</TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Typography variant="body1" className={classes.conflictQuestion}>
          Are you sure you want to overwrite?
        </Typography>
      </DialogContent>
      <DialogActions className={classes.conflictDialogActions}>
        <Button
          onClick={onClose}
          color="primary"
          variant="contained"
        >
          No
        </Button>
        <Button
          onClick={onConfirm}
          color="primary"
          variant="contained"
          autoFocus
        >
          Yes, Overwrite
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConflictDialog;
